document.addEventListener('DOMContentLoaded', function () {
  let doc = document;
  let head = doc.getElementsByTagName('head')[0];

  const tagEmail = MD5Email;

  let criteoScript = document.createElement('script');
  criteoScript.type = 'text/javascript';
  criteoScript.src = '//static.criteo.net/js/ld/ld.js';
  criteoScript.async = true;
  head.appendChild(criteoScript);

  let script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = 'window.criteo_q = window.criteo_q || [];';
  script.innerHTML += 'window.criteo_q.push(';
  script.innerHTML += '{ event: "setAccount", account: 85067 },';
  script.innerHTML += '{ event: "setSiteType", type: "d" },';
  if (tagEmail != '') {
    script.innerHTML += '{ event: "setEmail", email:"' + tagEmail + '" },';
  }
  script.innerHTML += '{ event: "viewHome" }';
  script.innerHTML += ');';
  head.appendChild(script);
});
